// const myInformation = 
//   "I'm a creative frontend developer passionate about building responsive, user-friendly web applications. With a strong presence on platforms like INSTAGRAM and THREADS, I share tech content that helps others grow in tech and online branding. ";

const Home = () => {
    return(
        <div className="hero">
            <div className="overlay">
            <h1>Hi,</h1>
            <h1>I'm Prec10us</h1>
            <p>A Frontend Developer & Digital Product Builder</p>
            <a href="/projects" className="btn">View my work</a>

            </div>
        </div>
    )
};

export default Home;